import { ptPrimeVueTranslations } from '@/locales/primeVue/pt-primevue-translations'
import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import 'primeicons/primeicons.css';

import App from './App.vue'
import { registerDirectives } from './directives'
import { registerPlugins } from './plugins'
import './style.css'

const app = createApp(App)

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      primary: {
        0: '#03619C',
        100: '#BEE3F8',
        200: '#7ACBEB',
        300: '#46A8E1',
        400: '#1C89D7',
        500: '#03619C',
        600: '#03567A',
        700: '#02455A',
        800: '#013545',
        900: '#012132',
        950: '#011F2B',
      },
    },
    colorScheme: {
      light: {
        primary: {
          color: '#03619C',
          contrastColor: '#FFFFFF',
          hoverColor: '#1d92c4',
          activeColor: '#02455A',
        },
      },
    },
  },
})

app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: MyPreset,
    options: {
      prefix: 'p',
      darkModeSelector: '.dark-theme',
      cssLayer: false,
    },
  },
})

registerDirectives(app)
registerPlugins(app)
app.mount('#app')
